

import __layout_0 from '/builds/wartek-id/belajar-id/belajar.id-cms/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/builds/wartek-id/belajar-id/belajar.id-cms/src/layouts/blank.vue'),
'default': __layout_0,
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
